import { Routes } from '@angular/router';

import { HypeComponent } from '../../../Common/Layout/components/Hype/hype.component';

import { NewDistributionComponent } from '../../Targeting/components/Distribution/NewDistribution/new-distribution.component';
import { DistributionComponent } from '../../Targeting/components/Distribution/distribution.component';
import { DistributionDashboardComponent } from '../../Targeting/components/Distribution/Dashboard/distribution.dashboard.component';
import { DistributionReportComponent } from '../../Targeting/components/Distribution/DistributionReport/distribution.report.component';
import { DistributionDeactivateGuard } from '../guards/distribution-deactivate.guard';


export const distributionRoutes: Routes = [
    {
        path: '',
        component: HypeComponent,
        data: {title: 'Discover.distributions.browserTitle'}
    },
    {
        path: 'new',
        component: NewDistributionComponent,
        data: {title: 'Discover.distributions.browserTitle'}
    },
    {
        path: 'dashboard',
        component: DistributionDashboardComponent,
        data: {title: 'Discover.distributions.browserTitle.dashboard'}
    },
    {
        path: 'distribution',
        component: DistributionComponent,
        canDeactivate: [DistributionDeactivateGuard],
        data: {title: 'Discover.distributions.browserTitle'}
    },
    {
        path: 'distribution/:id',
        component: DistributionComponent,
        canDeactivate: [DistributionDeactivateGuard]
    },
    {
        path: 'distribution/:id/report',
        component: DistributionReportComponent,
        canDeactivate: [DistributionDeactivateGuard]
    },
    {
        path: '**',
        redirectTo: '/Discover/distributions'
    }
];
